$(function() {
    $('.toggle-password').on('click', function() {
        const input = $(this).closest('.input-group, .ds-input-group').find('input');
        const type = $(input).attr('type');
        const newType = type == 'password' ? 'text' : 'password';
        $(input).attr('type', newType);
    });
});